import {Brick, registerBrick, ErrorFlow, Transaction} from 'olympe';
import PurchaseRequestDM from '../../models/cloudobjects/PurchaseRequestDM';

/**
 * This brick creates a Purchase Request (Cloud Object) based on a PR json
 */
export default class CreatePurchaseRequestFromJSON extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pRJson
     * @param {function()} forwardEvent
     * @param {function(PurchaseRequestDM)} setPurchaseRequest
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [pRJson], [forwardEvent, setPurchaseRequest, setErrorFlow]) {
        const tx = new Transaction(true);
        const purchaseRequest = PurchaseRequestDM.create(tx);
        try {
            PurchaseRequestDM.updatePurchaseRequestFromJson(pRJson, purchaseRequest, tx);
        } catch (e) {
            return (ErrorFlow.create(`Impossible to update a PR from JSON: ${e}`, 1));
        }

        tx.execute()
            .then((tr) => {
                setPurchaseRequest(tr.getCreatedObjects()[0]);
                forwardEvent();
            })
            .catch((error) => setErrorFlow(ErrorFlow.create(`Impossible to create a PR from JSON: ${error}`, 1)));
    }
}

registerBrick('0196b032d3520ee24f0d', CreatePurchaseRequestFromJSON);
